import React from 'react';
import './AppInfo.css';
import appIcon from './appicon.png';
import productImage3 from './product3.png';
import productImage4 from './product4.png';
import productImage5 from './product5.png';

const AppInfo: React.FC = () => {
  return (
    <section className="app-info">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 text-center">
            <img src={appIcon} alt="App Icon" className="rounded img-fluid app-icon" />
          </div>
          <div className="col-md-8 my-3">
            <h2>About Kubo TapTap</h2>
            <p>Kubo TapTap is a magical discovery game where children explore themed worlds like the Ocean, Forest, and even School! By tapping on beautiful floating objects, kids learn their names and pronunciations in both English and Vietnamese. It's designed to be simple, engaging, and perfect for early childhood development.</p>
          </div>
          <div className="col-md-12 mt-5">
            <img src={productImage3} alt="Product 3" className="img-fluid rounded shadow-lg mb-5" />
            <img src={productImage4} alt="Product 4" className="img-fluid rounded shadow-lg mb-5" />
            <img src={productImage5} alt="Product 5" className="img-fluid rounded shadow-lg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppInfo;
